import React from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '../../../store/reducer-main';
import PageLayout from '../../components/common/PageLayout';
import SettingsHeader from '../../components/common/settings/sections/SettingsHeader';
import AuthSection from '../../components/common/settings/sections/AuthSection';
import SubscriptionSection from '../../components/common/settings/sections/SubscriptionSection';
import PaymentMethodSection from '../../components/common/settings/sections/PaymentMethodSection';
import BillingInformationSection from '../../components/common/settings/sections/BillingInformationSection';
import theme from '../../theme';
import { useDisclosure } from '@heroui/modal';
import CustomModal from '../../components/common/CustomModal';
import ModifyPlanModalContent from '../../components/common/settings/modals/ModifyPlanModalContent';
import { SubsctiptionType } from '../../../types/common';
import ModifyBillsDataModalContent from '../../components/common/settings/modals/ModifyBillsDataModalContent';
import ModifyPayemntMethodModaContent from '../../components/common/settings/modals/ModifyPayemntMethodModaContent';
import { MembershipType } from '../../../enums/profile';
import { formatDate } from '../../../helpers/utils';
import { getClientSecretFromStripeIntent, getUserTransactions, interruptSubscriptionRenewal, processCardPayment, purchaseStripeSubscription } from '../../../service/common/stripe';
import { loadStripe, Stripe, StripePaymentElementChangeEvent, } from '@stripe/stripe-js';
import { toast } from 'react-toastify';
import TextButton from '../../components/common/TextButton';
import { deleteAuthUser } from '../../../service/profile';
import { signOut } from '../../../service/common/firebase';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import TransactionsTable from '../../components/common/settings/TransactionsTable';
import Typography from '../../components/common/Typography';
import { Button as NUIButton } from '@nextui-org/react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Button from '../../components/common/Button';

const TABLE_PAGE_SIZE = 6;

export default function SettingsPage() {

  const { userProfile,paymentMethod } = useSelector((state: StoreState) => state.profile);
  const {
    products,
    loadingProducts,
    stripeInstance,
  } = useSelector((state: StoreState) => state.stripe);
  const subscriptionModal = useDisclosure();
  const billsDataModal = useDisclosure();
  const paymentMethodModal = useDisclosure();

  const [loadingPurchase, setLoadingPurchase] = React.useState<boolean>(false);
  const [loadingDelete, setLoadingDelete] = React.useState<boolean>(false);
  const [loadingInterrupt, setLoadingInterrupt] = React.useState<boolean>(false);
  const [subscriptionType,setSubscriptionsType]=React.useState<SubsctiptionType>("month")
  const [clientSecret,setClientSecret]=React.useState<string | undefined>(undefined)
  const [stripeElement,setStripeElement]=React.useState<Stripe | null>(null)
  const [paymentMethodCompleted, setPaymentMethodCompleted] = React.useState<boolean>(false);
  const [isModifyPaymentMehodPress, setIsModifyPaymentMehodPress] = React.useState<boolean>(false);
  const [newPlanPurchaseModalOpen, setNewPurchasePlanModalOpen] = React.useState<boolean>(false);
  // transazioni
  const [transactionsTablePage, setTransactionsTablePage] = React.useState<number>(1);
  const [moreTransactionsExist, setMoreTransactionsExist] = React.useState<boolean>(false);
  const [loadingTransactions, setLoadingTransactions] = React.useState<boolean>(false);
  const [transactions, setTransactions] = React.useState<any[]>([]);
  // modale conferma
  const [deleteAccountConfirmationModalOpen, setDeleteAccountConfirmationModaleOpen] = React.useState<boolean>(false);
  const [interruptConfirmationModal, setInterruptConfirmationModal] = React.useState<boolean>(false);

  React.useEffect(() => {
    initTransactionsTable();
  }, []);

  const initTransactionsTable = async () => {
    try {
      setLoadingTransactions(true);
      setTransactionsTablePage(1);
      const newTransactions = await getUserTransactions({ endBefore: null, startAfter: null, size: TABLE_PAGE_SIZE });
      setMoreTransactionsExist(!!newTransactions.has_more);
      setTransactions(newTransactions.data ?? []);
      console.log({newTransactions});
      setLoadingTransactions(false);
    } catch (error) {
      console.log(error);
      setLoadingTransactions(false);
      setMoreTransactionsExist(false);
      toast.error('Non è stato possibile recuperare le transazioni');
    }
  }

  const fecthNextTablePage = async () => {
    try {
      if (!moreTransactionsExist || transactions.length === 0) return;
      setLoadingTransactions(true);
      const newTransactions = await getUserTransactions({ endBefore: null, startAfter: transactions[transactions.length - 1].id, size: TABLE_PAGE_SIZE });
      setMoreTransactionsExist(!!newTransactions.has_more);
      setTransactions(newTransactions.data ?? []);
      setTransactionsTablePage(prev => prev + 1);
      console.log({newTransactions});
      setLoadingTransactions(false);
    } catch (error) {
      console.log('next err', error);
      setMoreTransactionsExist(false);
      setLoadingTransactions(false);
      toast.error('Si è verificato un errore nel caricamento delle transazioni');
    }
  }

  const fetchPrevTablePage = async () => {
    try {
      /* if (transactionsTablePage === 1 || transactions.length === 0) return;
      setLoadingTransactions(true);
      const newTransactions = await getUserTransactions({ endBefore: transactions[0].id, startAfter: null, size: TABLE_PAGE_SIZE });
      setMoreTransactionsExist(!!newTransactions.has_more);
      setTransactions(newTransactions.data ?? []);
      setTransactionsTablePage(prev => prev - 1);
      console.log({newTransactions});
      setLoadingTransactions(false); */
      initTransactionsTable();
    } catch (error) {
      console.log('prev err', error);
      setMoreTransactionsExist(false);
      setLoadingTransactions(false);
      toast.error('Si è verificato un errore nel caricamento delle transazioni');
    }
  }

  const renewalDate = React.useMemo(() => {
    const membershipData = userProfile?.membership;
    if (!membershipData) return null;
    const planEndDate = membershipData.type === MembershipType.SUBSCRIPTION
      ? membershipData.subscriptionData.created * 1000
      : membershipData.tsEnd;
    const date = new Date(planEndDate);
    return formatDate(date);
  }, [userProfile]);
  
  const onPaymentElementChange = (
    e: StripePaymentElementChangeEvent
  ) => {
    setPaymentMethodCompleted(e.complete);
  }

  const onSubscriptionModifyPress=()=>{
    subscriptionModal.onOpen()
  }
  
  const setSubscriptionTypeHandler=(subType:SubsctiptionType)=>{
    setSubscriptionsType(subType)
    console.log(subType)
  }
  
  const onBillsDataModifyPress=()=>{
    billsDataModal.onOpen()
  }

  const onPaymentMehodModifyPress=async()=>{
    try {
      if(!userProfile)return 
      const payload={
          stripeCustomerId:userProfile?.stripeCustomer.id
      }
      setIsModifyPaymentMehodPress(true)
      const {data}= await getClientSecretFromStripeIntent(payload)
      const _clientSecret= data
      setClientSecret(_clientSecret)
      const stripeIntent = await loadStripe(process.env.REACT_APP_STRIPE_TEST_PUBLIC_KEY as string)
      setStripeElement(stripeIntent)
      paymentMethodModal.onOpen();
      setIsModifyPaymentMehodPress(false)
    } catch (error) {
      toast.error("Errore interno , per favore riprova tra poco")
      setIsModifyPaymentMehodPress(false)
      console.log(error)
    }
  }

  const onAccountDelete = async() => {
    try {
      if (!userProfile) return;
      setLoadingDelete(true);
      const cfRes = await deleteAuthUser();
      console.log('cf res data', cfRes);
      signOut();
      setLoadingDelete(false);
    } catch (error) {
      setLoadingDelete(false);
      console.log('err', error);
    }
  }

  const onInterruptSubscription = async () => {
    try {
      setLoadingInterrupt(true);
      const cfRes = await interruptSubscriptionRenewal();
      setTimeout(() => {
        window.location.reload();
      }, 500);
      console.log({cfRes});
      setLoadingInterrupt(false);
      setInterruptConfirmationModal(false);
    } catch (error) {
      console.log('err', error);
      setLoadingInterrupt(false);
      toast.error('Si è verificato un errore');
    }
  }

  const onPurchasePlan = async (
    priceId: string
  ) => {
    try {
      setLoadingPurchase(true);
      const intent = await purchaseStripeSubscription(priceId);
      console.log(intent);
      const intentStatus = intent.status;
      if (intentStatus === 'requires_action') {
        const client_secret = intent.client_secret;
        if (!stripeInstance || !client_secret) throw 'Invalid client secret';
        const { error, paymentIntent } = await processCardPayment(stripeInstance, client_secret); 
        if (error) throw 'Error';
        console.log('success', paymentIntent);
      } 
      toast.success('Pagamento confermato');
      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      setLoadingPurchase(false);
      toast.error('Si è verificato un errore');
      console.log('PURCH ERR', error);
    }
  }

  return (
    <PageLayout nestedPage>
      <SettingsHeader startDate={renewalDate??""} lastModifyDate={"--"} />
      <div
      className='flex flex-col w-full h-full mt-6 p-4' style={{
        borderRadius: theme.sizing.x2,
        backgroundColor: theme.color.background,
        border: '1.5px solid lightgray',
        paddingLeft: theme.sizing.x5,
        paddingRight: theme.sizing.x5
      }}
       >
        <AuthSection/>
        <SubscriptionSection 
          onPurchasePlan={onPurchasePlan}
          purchaseLoading={loadingPurchase}
          interruptLoading={loadingInterrupt}
          onSubscriptionModifyPress={onSubscriptionModifyPress}
          onInterruptSubscription={() => setInterruptConfirmationModal(true)} />
        <PaymentMethodSection isModifyPaymentMehodPress={isModifyPaymentMehodPress} onPaymentMehodModifyPress={onPaymentMehodModifyPress}/>
        <BillingInformationSection onBillsDataModifyPress={onBillsDataModifyPress}/>
        <Typography className='mt-6 mb-3' variant='display'>TRANSAZIONI</Typography>
        {
          transactions.length === 0 ? (
            <Typography>Non sono presenti transazioni</Typography>
          ) : (
            <React.Fragment>
              <TransactionsTable 
                data={transactions} />
              <div className='flex justify-end gap-4 items-center mt-auto'>
                <NUIButton isIconOnly size='sm' onClick={fetchPrevTablePage} isDisabled={transactionsTablePage === 1}>
                  <ArrowBackIosNewIcon fontSize='small'/>
                </NUIButton>
                <p>{transactionsTablePage}</p>
                <NUIButton isIconOnly size='sm' onClick={fecthNextTablePage} isDisabled={!moreTransactionsExist}>
                  <ArrowForwardIosIcon fontSize='small'/>
                </NUIButton>
              </div>
            </React.Fragment>
          )
        }
      </div>
      <CustomModal 
        isOpen={subscriptionModal.isOpen} 
        content={<ModifyPlanModalContent setSubscriptionTypeHandler={setSubscriptionTypeHandler} subscriptionType={subscriptionType}/>} 
        onOpenChange={subscriptionModal.onOpenChange} />
      <CustomModal content={<ModifyBillsDataModalContent billsDataModal={billsDataModal} />} isOpen={billsDataModal.isOpen} onOpenChange={billsDataModal.onOpenChange}/>
      <CustomModal content={<ModifyPayemntMethodModaContent clientSecret={clientSecret} paymentMethodModal={paymentMethodModal}  onPaymentElementChange={onPaymentElementChange}  stripeElement={stripeElement} />}       
        isOpen={paymentMethodModal.isOpen} onOpenChange={paymentMethodModal.onOpenChange}/>
      <TextButton 
        textColorVariant='error'
        disabled={loadingDelete}
        icon={<DeleteOutlineRoundedIcon style={{color: theme.color.error}}/>}
        style={{marginLeft: 'auto', marginRight: 'auto', marginTop: theme.sizing.x3}}
        title='ELIMINA ACCOUNT'
        onPress={() => setDeleteAccountConfirmationModaleOpen(true)} />
      <CustomModal 
        isOpen={deleteAccountConfirmationModalOpen}
        onOpenChange={setDeleteAccountConfirmationModaleOpen}
        content={
          <div className='my-4'>
            <Typography style={{textAlign:"center"}} variant="display">Desideri procedere con la cancellazione dell'account?</Typography>
            <div className='flex flex-col justify-center mt-8 gap-4'>
              <Button 
                disabled={loadingDelete}
                loading={loadingDelete}
                title='Conferma'
                onClick={onAccountDelete}/>
            </div>
          </div>
        }/>
        <CustomModal 
          isOpen={interruptConfirmationModal}
          onOpenChange={setInterruptConfirmationModal}
          content={
            <div className='my-4'>
              <Typography style={{textAlign:"center"}} variant="display">Desideri procedere con l'interruzione dell'abbonamento?</Typography>
              <div className='flex flex-col justify-center mt-8 gap-4'>
                <Button 
                  title='Conferma'
                  disabled={loadingInterrupt}
                  loading={loadingInterrupt}
                  onClick={onInterruptSubscription}/>
              </div>
            </div>
          }/>
    </PageLayout>
  )
}